export const validateFirstName = (value) => {
    if (!value) {
        return 'First Name is required*';
    }
    const noSpacePattern = /^\S+$/; 
    return noSpacePattern.test(value) ? true : 'First name cannot contain spaces';
};

export const validateLastName = (value) => {
    if (!value) {
        return 'Last name is required*';
    }
    const noSpacePattern = /^\S+$/; 
    return noSpacePattern.test(value) ? true : 'Last name cannot contain spaces';
};

export const validateEmail = (value) => {    
    if(!value){
        return 'Email is Required*';
    }
    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;    
    return emailPattern.test(value) ? undefined : 'Invalid Email';   
};

export const validatePhoneNumber = (value) => {
  const str = String(value ?? "").trim();
  if (str === "") return "Phone number is required*";
  const isValid = /^(\+91)?[6-9][0-9]{9}$/.test(str);
  return isValid ? true : "Phone number must be a valid 10-digit number";
};

export const validateAlternateNumber = (value) => {
  const str = String(value ?? "").trim();
  if (str === "") return true;
  const isValid = /^(\+91)?[6-9][0-9]{9}$/.test(str);
  return isValid ? true : "Alternate number must be a valid 10-digit number";
};


export const validatePassword = (value) => {
    if (!value) {
        return 'Password is required*';
    }
    const pattern = /^(?=.*[!@#$%^&*()_+\{\}\[\]:;"'<>,.?~`\\|/\-])(?=.*\d)[A-Z][A-Za-z\d!@#$%^&*()_+\{\}\[\]:;"'<>,.?~`\\|/\-]*$/;
    const trimmedValue = value.trim();
    return pattern.test(trimmedValue) ? true : 'Invalid Password';
};